<template>
  <memlist-card>
    <m-row class="mt-4">
      <m-col lg="12">
        
        <h4 class="text-center mx-auto">{{$t('MEMBER.YOUR_SECTION')}}</h4>
        </m-col>
    </m-row>
    <m-row>
      <m-col lg="12" class="text-center mx-auto mt-4">

        <memlist-select-input2
          style="width: 100%;"
          :items="section_items"
          v-model="selected_section_id"
          @input="changed_section_input"
          layout="vertical"
          size="lg"
        />
      </m-col>
    </m-row>
    <m-row v-if="show_save" class="mt-4">
      <m-col lg="12" class="text-center mx-auto">
        <memlist-button @click="save_section">{{ $t('COMMON.SAVE')}}</memlist-button>
      </m-col> 
    </m-row>
  </memlist-card>

</template>

<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { is_mobile } from '@/core/services/utils';


export default {

  name: 'MemberSectionAsAttributeComponent',

  props: ['member','company'],
  emits: ['save_data'],
  mixins: [ toasts ],

  components: {

  },

  watch: {
  
  },

  computed: {
    is_mobile() {
      return is_mobile();
    },
  },

  methods: {
    changed_section_input(val) {
      if (val !== this.member.section_id) {
        this.show_save = true;
      }
    },
    async save_section() {
      if (this.selected_section_id) {
        await this.put_section(this.selected_section_id);
      }
      
      this.save_data();
    },

    async save_data() {

      this.$emit('save_data', this.member);

    },


    async fetch_sections() {
      try {
        const res = await axios.get(`/property_group/sections`);

        if (res.status === 200) {
          console.log('sections', res.data);
          this.section_items = res.data.map(i => ({ value: i.prop_id, text: i.name }));
        }
      }
      catch (err) {
        console.error('fetch_sections', err);
      }
    },


    async put_section(prop_id) {
      try {
        const res = await axios.put(`/property_group/section/${prop_id}`, {});

        if (res.status === 200) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('MEMBER.UPDATED'));
          return true;
        }
      }
      catch (err) {
        console.error('fetch_profile_attributes', err);
      }

      return false;
    },


  },

  async mounted() {
    this.selected_section_id = this.member.section_id;
    await this.fetch_sections();
  },

  data() {
    return {
      section_items: [],
      selected_section_id: null,
      show_save: false,
    };
  }
};

</script>

